var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroupPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.108,
    height: 71.633,
    viewBox: "0 0 54.108 71.633",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_4421",
    x: 0,
    y: 0,
    width: 54.108,
    height: 71.633,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4811",
    "data-name": "Group 4811",
    transform: "translate(17632 14683.634)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(-17623 -14677.634)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 13.721,
    cy: 13.721,
    r: 13.721,
    transform: "translate(4.364 4.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4421-2",
    "data-name": "Path 4421",
    d: "M18.054,0A18.054,18.054,0,0,0,0,18.054c0,9.971,18.054,35.579,18.054,35.579S36.108,28.025,36.108,18.054A18.054,18.054,0,0,0,18.054,0m0,30.965A12.911,12.911,0,1,1,30.965,18.054,12.911,12.911,0,0,1,18.054,30.965",
    transform: "translate(9 6)",
    fill: "#047BC1"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(-17612.938 -14666.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4506",
    "data-name": "Path 4506",
    d: "M132.8,132.8a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,132.8,132.8Zm-1.466.8A3.33,3.33,0,0,0,128,136.924a.667.667,0,0,0,.667.667h8.257a.667.667,0,0,0,.667-.667,3.33,3.33,0,0,0-3.329-3.329Z",
    transform: "translate(-124.803 -124.803)",
    fill: "#047BC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4507",
    "data-name": "Path 4507",
    d: "M5.594,2a2,2,0,1,0-2,2,2,2,0,0,0,2-2Zm9.191,0a2,2,0,1,0-2,2,2,2,0,0,0,2-2ZM2.665,4.8A2.666,2.666,0,0,0,0,7.46a.534.534,0,0,0,.532.532H5.879A3.189,3.189,0,0,1,4.8,5.594a3.421,3.421,0,0,1,.047-.557A2.641,2.641,0,0,0,3.731,4.8Zm7.443,3.2h5.345a.532.532,0,0,0,.532-.532A2.666,2.666,0,0,0,13.319,4.8H12.255a2.679,2.679,0,0,0-1.114.242,3.143,3.143,0,0,1,.047.557A3.2,3.2,0,0,1,10.108,7.992Z",
    fill: "#888",
    opacity: 0.8
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroupPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group-pin.7170dd8c31828c2105541051413a120c.svg";